import React from 'react';
import './Tablecard.css';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Context/Authcontext';

function Tablecard(props) {

    const { userdata, isloggedin } = useAuth();

    const addtoCartFunc = (num) => {
        if (isloggedin) {
            fetch(`https://pentadeco.in/api/addtocart`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ productId: props.id, quantity: num, userId: userdata?._id })
            }).then(res => res.json()).then(data => {
                if (data.success) {
                    window.location.reload();
                }
            })
        }
    }

    const displayName = props.name.length > 70 ? props.name.slice(0, 70) + '...' : props.name;
    const isCartPage = window.location.pathname === '/cart';

    return (
        <div className='cart-item-card border rounded-brand overflow-hidden'>
            <div className="d-flex align-items-start gap-3 p-3">
                <Link to={`/${props?.id}/${props?.name?.replace(/ /g, '_')}`} className="flex-shrink-0">
                    <img src={props?.img} alt={props?.name} className="cart-item-img rounded-brand-sm" />
                </Link>
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <Link
                        to={`/${props?.id}/${props?.name?.replace(/ /g, '-')}`}
                        className="nav-link mb-1 body-font-semibold text-capitalize lh-sm cart-item-name"
                    >
                        {displayName}
                    </Link>
                    <p className="mb-0 text-muted fs-sm mt-1">Unit price: ₹{props?.disprice}</p>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {isCartPage && (
                            <div className="cart-qty-control">
                                <button className="cart-qty-btn" onClick={() => addtoCartFunc(-1)}>−</button>
                                <span className="cart-qty-value">{props.quantity}</span>
                                <button className="cart-qty-btn" onClick={() => addtoCartFunc(1)}>+</button>
                            </div>
                        )}
                        <p className="mb-0 body-font-bold ms-auto text-brand-secondary">
                            ₹{props?.disprice * props?.quantity}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Tablecard;
